// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCDappK19qpF7Vlc6_HjHyuX_LFmz4aF6g",
    authDomain: "ema-john-simple-b15fb.firebaseapp.com",
    projectId: "ema-john-simple-b15fb",
    storageBucket: "ema-john-simple-b15fb.appspot.com",
    messagingSenderId: "1066214169111",
    appId: "1:1066214169111:web:43e123e5faef86467a1a52"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;